import React, { useEffect, useState } from "react";
import { Button, Card, Input, Space, Checkbox, Menu, Dropdown, Tree, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import styles from "./component.module.css";

//Service import
import { fetchComponentData, getFormatedComponentJson, saveComponentToWorkFlow } from "../../../services/workFlowDiagramService";

const excludedDefaultLineKeys = [-1, -100]; // Define excluded keys

const Welcome = () => {
    const [nodeKey, setNodeKey] = useState("");
    const [possibleResponseData, setpossibleResponseData] = useState([]);
    const [setLineItem, setLineItems] = useState([]);

    const [treeData, setTreeData] = useState([]);
    const [selectedNode, setSelectedNode] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [aiAnalyse, setAiAnalyse] = useState(false);

    // Load initial data
    useEffect(() => {
        const fetchData = async () => {
            let data = await fetchComponentData(setNodeKey);
            console.log("fetchComponentData:", data);
            setComponentData(data);
        };

        fetchData();
    }, []);

    //#region Set component data
    const setComponentData = (processData) => {
        console.log("processData:", processData);
        if (processData?.configData) {
            const configData = processData.configData.configData;
            if (configData !== undefined) {
                setpossibleResponseData(configData.possibleResponse || []);
            }
        }
        // Load data for Line section
        if (processData?.configLines) {
            //Remove Default Lines and Bind to table
            processData.configLines.lines = processData.configLines.lines.filter(line => !excludedDefaultLineKeys.includes(line.key));

            const processedLines = processData.configLines.lines.map(item => ({ ...item, lineText: item.lineText.split('|')[0] }));
            setLineItems(processedLines || []);
        }
    }

    //Save component data to workflow  
    const compConfig = null;
    const linesData = null;
    saveComponentToWorkFlow(nodeKey, compConfig, linesData);

    const truncateText = (text, length = 20) => {
        return text.length > length ? text.substring(0, length) + "..." : text;
    };

    const addNode = (parentKey, type) => {
        const newNode = {
            key: Date.now(),
            title: truncateText("New " + type),
            fullTitle: "New " + type,
            type,
            aiAnalyse: false,
            children: []
        };

        if (!parentKey) {
            setTreeData([...treeData, newNode]);
        } else {
            const updateTree = (nodes) => nodes.map(node => {
                if (node.key === parentKey) {
                    return { ...node, children: [...node.children, newNode] };
                } else if (node.children.length) {
                    return { ...node, children: updateTree(node.children) };
                }
                return node;
            });
            setTreeData(updateTree(treeData));
        }
    };

    const saveNode = () => {
        if (!inputValue.trim()) return;
        const updateTree = (nodes) => nodes.map(node => {
            if (node.key === selectedNode.key) {
                return { ...node, title: truncateText(inputValue), fullTitle: inputValue, aiAnalyse };
            } else if (node.children.length) {
                return { ...node, children: updateTree(node.children) };
            }
            return node;
        });
        setTreeData(updateTree(treeData));
        setSelectedNode(null);
        setInputValue("");
        setIsEditing(false);
    };

    const removeNode = (key) => {
        const filterTree = (nodes) => nodes.filter(node => node.key !== key).map(node => ({
            ...node,
            children: filterTree(node.children)
        }));
        setTreeData(filterTree(treeData));
    };

    const handleRightClick = ({ node }) => (
        <Menu>
            {node.type === "question" ? (
                <Menu.Item onClick={() => addNode(node.key, "response")}>
                    Add Response
                </Menu.Item>
            ) : (
                <>
                    <Menu.Item onClick={() => addNode(node.key, "question")}>
                        Add Question
                    </Menu.Item>
                    <Menu.Item onClick={() => addNode(node.key, "response")}>
                        Add Response
                    </Menu.Item>
                </>
            )}
            <Menu.Item onClick={() => {
                setSelectedNode(node);
                setInputValue(node.fullTitle);
                setIsEditing(true);
                setAiAnalyse(node.aiAnalyse);
            }}>
                Edit
            </Menu.Item>
            <Menu.Item onClick={() => removeNode(node.key)} danger>
                Delete
            </Menu.Item>
        </Menu>
    );

    return (
        <div style={{ padding: 20, maxWidth: 600, margin: "auto" }}>
            <Button type="primary" icon={<PlusOutlined />} onClick={() => addNode(null, "question")}>
                Add Question
            </Button>

            {selectedNode && (
                <Card style={{ marginTop: 20, background: "#f9f9f9" }}>
                    <Space direction="vertical" style={{ width: "100%" }}>
                        <Input
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                        />
                        {selectedNode.type === "response" && (
                            <Checkbox checked={aiAnalyse} onChange={(e) => setAiAnalyse(e.target.checked)}>
                                AI Analyse
                            </Checkbox>
                        )}
                        <Space>
                            <Button type="primary" onClick={saveNode}>Save</Button>
                            <Button onClick={() => setSelectedNode(null)}>Cancel</Button>
                        </Space>
                    </Space>
                </Card>
            )}

            <div className="tree-container">
                <Tree
                    treeData={treeData}
                    blockNode
                    showLine
                    defaultExpandAll
                    titleRender={(node) => (
                        <Tooltip title={node.fullTitle} placement="top">
                            <Dropdown overlay={handleRightClick({ node })} trigger={["contextMenu"]}>
                                <span className="tree-node">{node.title}</span>
                            </Dropdown>
                        </Tooltip>
                    )}
                />
            </div>
        </div>
    );
};

export default Welcome;
